<template>
</template>

<script>
	import * as turf from "@turf/turf";
	import {mapState} from "vuex";
	import * as randomPoint from "random-points-on-polygon";
	import * as moment from "moment";
	import * as workerTimers from "worker-timers";
	import {get} from "idb-keyval";
	import PathFinder from "./PathFinder.js";

	export default {
		name: "Vehicles",
		mixins: [PathFinder],
		data() {
			return {

			}
		},
		computed: {
			...mapState([
				"assets_loaded",
				"load",
				"features",
				"vehicles",
				"vehicle_sprites",
				"sprites",
				"workers",
				"time",
				"companies",
				"zones",
				"paths",
				"vehicle_types",
				"debug"
			]),
			map() {
				return this.$store.state.map.map;
			},
			start_time() {
				return this.$config.start_time;
			},
			end_time() {
				return this.$config.end_time;
			},
			assetsLayer() {
				return this.$store.state.map.assetsLayer
			}
		},
		watch: {
			time() {
				this.moveVehicles();
			},
		},
		async mounted() {
			await this.createVehicles();
		},
		methods: {
			async createVehicles() {
				if (Object.keys(this.vehicles).length > 0) return;

				if (this.load) {
					await this.loadVehicles();
					return;
				}

				var id = 0;

				Object.keys(this.companies).forEach((company_id) => {

					let company = this.companies[company_id];

					if (!company.vehicles) return;

					for (let vehicle_type in company.vehicles) {
						var n = company.vehicles[vehicle_type];
						if (!n) continue;

						n = parseInt(n);
						if (!n) continue;

						var zone = this.$finder.first({'type': 'parking', 'terminal': '1', 'parking_vehicles': vehicle_type, 'companies': company.id}, this.zones);

						if (!zone) continue;
						var feature = this.features[zone.id];

						let points = randomPoint(n, feature.turf);


						points.forEach(point => {
							id++;
							let coords = this.$geo.toOL(point.geometry.coordinates);

							let vehicle = {
								id: 'v-'+id,
								type: vehicle_type,
								floor_level: zone.floor_level,
								path: null,
								status: 'at-zone',
								color: this.vehicle_types[vehicle_type].color,
								floor_level: zone.floor_level,
								zone: zone,
								name: this.vehicle_types[vehicle_type].label +' '+parseInt(100+id),
								speed: this.vehicle_types[vehicle_type].speed * 1.609344 / 3.6,
								company: company,
								img: this.vehicle_types[vehicle_type].img,
								workers: [],
								queue: [],
								on_board: [],
								full: false
							}

							this.$set(this.vehicles, vehicle.id, vehicle);
							vehicle.coordinates = coords;
							this.setSprite(vehicle);
						})
					}
				});

				this.assignWorkers();

			},
			async loadVehicles() {
				let data = await get(this.load);

				for (let i in data.vehicles) {
					let dw = data.vehicles[i];
					let vehicle = {};

					for (let key in dw) {
						if (key == 'coordinates') continue;
						vehicle[key] = dw[key];
					}
					this.$set(this.vehicles, vehicle.id, vehicle);
					vehicle.coordinates = dw.coordinates;
					this.setSprite(vehicle);
				}
			},
			setSprite(vehicle) {

				let sprite_img = require(`assets/img/sprites/${vehicle.img}`);

				let $sprite = new ol.Sprite({
					position: vehicle.coordinates,
					src: sprite_img,
					size: 75,
					scale: 0.25,
					frameRate: 0,
					states: {
						idle: {
							line: 0,
							length: 1
						}
					}
				});
				$sprite.id = vehicle.id;
				$sprite.setId(vehicle.id);
				$sprite.type = vehicle.type;
				$sprite.scale = 0.25;
				$sprite.size = 75;

				this.assetsLayer.addFeature($sprite);
				this.$set(this.vehicle_sprites, vehicle.id, $sprite);

				$sprite.on("change", () => {
					vehicle.coordinates = $sprite.getCoordinate();
					if (vehicle.type == 'transport') {
						vehicle.on_board.forEach((worker_id) => {
							let $worker_sprite = this.sprites[worker_id];
							$worker_sprite.setCoordinate(vehicle.coordinates);
						});
					}
				});

				$sprite.on('destination', (e) => {

					let route = vehicle.route.shift();
					vehicle.zone = route.parking_zone_id ? this.zones[route.parking_zone_id] : this.zones[route.zone_id];
					vehicle.status = 'at-zone';

					this.$asset.workersInVehicle(vehicle).forEach((worker) => {
						if (worker.driver) {
							if (worker.return_to){
								worker.target_zone_id = worker.return_to;
								worker.return_to = null;
							}
							let next = this.$finder.first({'driver_id': worker.id}, this.workers)
							if (!next) {
								worker.driver = false;
								worker.override = false;
							}
							else {
								worker.override = next.zone.id;
							}

							worker.route = null;
						}
						else if (vehicle.route.length == 0 || worker.target_zone_id == route.zone_id) {
							worker.in_vehicle = false;
							this.$finder.remove(vehicle.on_board, worker.id);
							worker.route = null;
							worker.zone = vehicle.zone;
							worker.status = 'finding-path';
							worker.vehicle_id = null;
							// console.log(worker, route);
							// if (worker.target_zone_id == route.zone_id) {
							// 	if (worker.target_zone_id == worker.override) worker.override = null;
							// 	worker.target_zone_id = null;
							// }

						}
					});



					if (!vehicle.route.length) {
						$sprite.setState('idle');
						vehicle.route = null;
					}

				});
			},
			assignWorkers() {

				for (let i in this.workers) {
					let worker = this.workers[i];
					if (worker.vehicles === undefined) worker.vehicles = [];
					for (let vehicle_type in this.vehicle_types) {
						let vehicle = this.$finder.first({'company.id': worker.company.id, 'full': false, type: vehicle_type}, this.vehicles);
						if (!vehicle) continue;
						if (vehicle.type != 'transport' && worker.vehicles.length > 0) continue;
						vehicle.workers.push(worker.id);
						if (vehicle.type != 'transport') worker.vehicles.push(vehicle.id);

						if (vehicle.workers.length >= this.vehicle_types[vehicle.type].capacity) vehicle.full = true;
					}
				}
			},
			moveVehicles() {

				let vehicles = this.$finder.all({ type: 'transport'}, this.vehicles);
				// MOVES ONLY TRANSPORT. FOR OTHER VEHICLE TYPES, COPY WORKER'S POSITION, NO ROUTE IS NEEDED;
				for (let i in vehicles) {
					let vehicle = vehicles[i];
					if (!this.$asset.queueCleared(vehicle)) continue;

					if (vehicle.route && vehicle.route.length) {
						if (vehicle.status != 'going') {
							let $sprite = this.vehicle_sprites[vehicle.id];
							$sprite.setPath(vehicle.route[0].path, vehicle.speed);
							vehicle.status = 'going';
						}
						continue;
					}

					let route = [];

					vehicle.on_board.forEach((worker_id) => {
						let worker = this.workers[worker_id];
						if (worker.route && (worker.target_zone_id || worker.override)) {
							worker.route.forEach(item => {
								if (!route.find(o => o.zone_id == item.zone_id)) route.push(item);
							});
						}
					});

					if (route.length == 0) continue;

					route = this.$finder.order(route, 'length');
					let origin;
					let path;
					route.forEach((item, index) => {

						let zone = this.zones[item.zone_id];
						origin = (route[index - 1] != undefined ) ? route[index - 1].path[route[index - 1].path.length - 1] : vehicle.coordinates;

						let target_zone_id = item.zone_id;
						if (vehicle.type == 'transport') {
							let parking_zone = this.$zone.getClosestParking(zone, "*", 'transport');
							if (parking_zone) {
								item.parking_zone_id = parking_zone.id;
								target_zone_id = parking_zone.id;
							}
						}


						path = this._getPath(vehicle, origin, target_zone_id);
						item.path = path;
						item.length = turf.length(turf.lineString(this.$geo.toTurf(path)));
					});

					vehicle.route = route;

					if (this.debug) this.$geo.drawPath(route, 'red');

				}
			}
		}
	};
</script>
